export const getDirtyValues = (
  values: Array<[string, string | number]>,
  initialValues: Record<string, string | number>
) => {
  return values.filter(([key, value]) => initialValues[key] !== value).map(([key, _value]) => key)
}
